import { render, staticRenderFns } from "./IrEstimationSearchIds.vue?vue&type=template&id=386cdc5a&"
import script from "./IrEstimationSearchIds.vue?vue&type=script&lang=js&"
export * from "./IrEstimationSearchIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports